import styled from '@emotion/styled';
import { Text } from '../components/Typography';
import { Container, GridItem } from '../components/Layout';
import { signout } from 'core/auth/userService';
import backgroundImage from 'assets/AW-background.png';
import activewebLogo from 'assets/ActiveWebCMLogo.png';

interface ErrorPageProps {
    errorMessage: string;
  }
function logout() {
    localStorage.setItem('logout-event', 'logout' + Math.random());
    signout();
}

export function ErrorPage({errorMessage}: Readonly<ErrorPageProps>) {
    return (
        <BackgroundContainer>
            <BackgroundImage src={backgroundImage} alt="ActiveWeb World"/>
            <MainContainer alignItems="center" direction="column" justify="center">
                <GridItem>
                    <PanelDefault style={{borderRadius: '4px'}}>
                        <img style={{paddingBottom: '20px'}} src={activewebLogo} alt="ActiveWeb"/>
                        <Text fontSize="m" color='black' align={'center'}>{ errorMessage }</Text>
                        <Button id="next" type="submit" onClick={logout}>Logout</Button>
                    </PanelDefault>
                </GridItem>
            </MainContainer>
        </BackgroundContainer>
    );
}

const MainContainer = styled(Container)`
  min-height: 100vh
`;
const BackgroundContainer = styled.div`
    alignItems="center" direction="column" justify="center"
    position: fixed; /* Create a stacking context */
    width: 100%;
    height: 100%; /* Full viewport height */
    z-index: 0;
`;
const BackgroundImage = styled.img`
    width:100%;
    height: 100%;
    position: fixed; 
    display:block
    top: 0;
    left: 0;
    object-fit: cover; /* Ensure the image covers the container */
    z-index: 0; 
    overflow: hidden;
`

const PanelDefault = styled.div`
    max-width: 350px;
    position: absolute;
    padding:35px 30px;
    margin-top:-120px;
    margin-left: -180px;
    margin-bottom:auto;
    height:250px;
    background-color:#fff;
    alignItems="center"
    
`;

const Button = styled.button`
    box-sizing: border-box;
    background-image: none;
    background-color: #303A52;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 25px;
    margin-left: 90px;
    padding-top: 6px;
    padding-bottom: 8px;
    text-align: center;
    color: #fff;
    width: 100px;
    height: 30px;
    color: #fff;
`;
